<template>
  <div class="code-editor-window">
    <div class="window-header">
      <div class="window-controls">
        <div class="control close"></div>
        <div class="control minimize"></div>
        <div class="control maximize"></div>
      </div>
      <div class="window-title">{{ filename }}</div>
    </div>
    <div class="code-content">
      <div class="line-numbers">
        <span v-for="lineNumber in totalLines" :key="lineNumber">{{ lineNumber }}</span>
      </div>
      <div class="code-text">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue'

interface Props {
  filename: string
  totalLines: number
}

defineProps<Props>()
</script>

<style scoped>
.code-editor-window {
  background: #1e1e1e;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 8px 25px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  width: 100%;
  max-width: 500px;
  transform: perspective(1000px) rotateY(0deg);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.code-editor-window:hover {
  transform: perspective(1000px) rotateY(-2deg) scale(1.02);
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4), 0 10px 30px rgba(0, 0, 0, 0.25);
}

.window-header {
  background: #2d2d2d;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #404040;
}

.window-controls {
  display: flex;
  gap: 8px;
}

.control {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.control.close {
  background: #ff5f57;
}

.control.minimize {
  background: #ffbd2e;
}

.control.maximize {
  background: #28ca42;
}

.window-title {
  color: #a0a0a0;
  font-size: 13px;
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
}

.code-content {
  display: flex;
  background: #1e1e1e;
  min-height: 180px;
}

.line-numbers {
  background: #2d2d2d;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #404040;
  min-width: 40px;
}

.line-numbers span {
  color: #6e7681;
  font-size: 12px;
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  line-height: 20px;
  text-align: right;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.code-text {
  padding: 16px;
  flex: 1;
  overflow-x: auto;
}

@media (max-width: 768px) {
  .code-editor-window {
    max-width: 100%;
  }
}
</style>